import Modal from '../../components/modal.js';

namespace('IO.Views.PaymentDeviceTypes', function (exports) {
  'use strict';

  var AffectedPaymentDeviceModal = Modal.extend({
    callbacks: [],
    template: 'payment_devices/impacted_payment_devices',

    dom: {
      OK_BUTTON: '#answer-ok',
    },

    open: function (stores) {
      this.stores = stores;
      this._setupRender();
    },

    events: function () {
      var events = [];

      events['click ' + this.dom.OK_BUTTON] = 'close';

      return events;
    },

    _setupRender: function () {
      this.wait = false;
      this.setContent(
        this.renderTemplate(
          {
            stores: this.stores,
            width: 800,
            height: 500,
          },
          this.template,
        ),
      );

      this.show(
        {
          top: 100,
          left: ($(window).width() - 800) / 2,
        },
        {
          width: 800,
        },
      );
    },
  });

  exports.AffectedPaymentDeviceModal = AffectedPaymentDeviceModal;
});
